module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0154.jpg?v=882e9fe9";